/* eslint-disable max-lines-per-function */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/rootReducer";

import PreviewsList from "./views/previews-list";
import PreviewsActions from "./views/previews-actions";
import PreviewsCategory from "./views/previews-category";
import PreviewsCategoryMobile from "./views/previews-category-mobile";
import PreviewsDescription from "./views/previews-description";

import content from "./content";
import { archiveDownload, imageDownload } from "./utils/download";

import {
  setPreviewSelected,
  addPreviewSelected,
  showPreviewEditPopup,
} from "./redux/actions";
import React, { useCallback, useEffect, useState } from "react";
import * as analytics from "./analytics";
import useEmblaCarousel from "embla-carousel-react";
import previewActions from "../../redux/actions/previewActions";

const PreviewsContainer = ({
  service,
  image,
  width,
  height,
  imageName,
  uploadElement,
  showDescription,
}: {
  service: string;
  image: string;
  width: number;
  height: number;
  imageName: string;
  uploadElement: any;
  showDescription: boolean;
}): JSX.Element => {
  const dispatch = useDispatch();

  const { previewCategory, previewSetCategory, previewSetSelected } =
    previewActions();

  const [isVisiblePrev, setIsVisiblePrev] = useState(false);
  const [isVisibleNext, setIsVisibleNext] = useState(true);

  const [viewportRef, embla] = useEmblaCarousel({
    containScroll: "keepSnaps",
    dragFree: true,
    align: "center",
    speed: 5,
  });

  const scrollPrev: Function = useCallback(() => {
    if (!embla) return;
    embla.scrollPrev();
    analytics.sendClickCategoryScroll();
  }, [embla]);
  const scrollNext: Function = useCallback(() => {
    if (!embla) return;
    embla.scrollNext();
    analytics.sendClickCategoryScroll();
  }, [embla]);

  const onSelect: () => void = useCallback(() => {
    if (!embla) return;
    embla.canScrollPrev() ? setIsVisiblePrev(true) : setIsVisiblePrev(false);
    embla.canScrollNext() ? setIsVisibleNext(true) : setIsVisibleNext(false);
  }, [embla]);

  useEffect(() => {
    if (!embla) return;
    embla.on("select", onSelect);
    onSelect();
  }, [embla, onSelect]);

  const previewsSelected = useSelector(
    (state: RootState) => state.previewReducer.selected
  );
  const previewsCategorySelected = useSelector(
    (state: RootState) => state.previewReducer.category
  );
  const previewPosition = [
    ...useSelector((state: RootState) => state.previewReducer.previewPosition),
  ];

  const contentData = content(service);


  return (
    <section className="previews">
      <div className="previews__container container">
        <h2>{contentData.title}</h2>
        <PreviewsCategory
          categories={contentData.categories}
          previewCategory={previewCategory}
          previewSetSelected={previewSetSelected}
          isVisiblePrev={isVisiblePrev}
          isVisibleNext={isVisibleNext}
          viewportRef={viewportRef}
          previewSetCategory={previewSetCategory}
          scrollNext={scrollNext}
          scrollPrev={scrollPrev}
          analytics={analytics}
        />

        <PreviewsCategoryMobile
          categories={contentData.categories}
          analytics={analytics}
        />
        <PreviewsActions
          countSelected={previewsSelected.length}
          imageIsAdded={!image}
          previewActiveCategory={previewsCategorySelected}
          selectAllPreview={() =>
            dispatch(
              setPreviewSelected(
                contentData.previews[previewsCategorySelected].map(
                  (preview, key) => key
                )
              )
            )
          }
          deSelectPreview={() => dispatch(setPreviewSelected([]))}
          downloadImages={() => {
            archiveDownload(
              image,
              imageName,
              contentData.previews[previewsCategorySelected],
              width,
              height,
              previewPosition,
              previewsSelected
            );
          }}
          previewsSelected={previewsSelected}
          analytics={analytics}
        />
        <PreviewsList
          activeCategory={previewsCategorySelected}
          previews={contentData.previews}
          previewsSelected={previewsSelected}
          uploadElement={uploadElement}
          image={image}
          imageName={imageName}
          width={width}
          height={height}
          previewPosition={previewPosition}
          previewCategory={previewsCategorySelected}
          selectPreview={addPreviewSelected}
          dispatch={dispatch}
          showDescription={showDescription}
          imageDownload={imageDownload}
          showPreviewEditPopup={showPreviewEditPopup}
          analytics={analytics}
          service={service}
        />
        <PreviewsDescription
          titles={contentData.titles}
          descriptions={contentData.descriptions}
          activeCategory={previewsCategorySelected}
        />
      </div>
    </section>
  );
};

export default PreviewsContainer;
